<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-logo" @click="goHome">FilmHive</div>

      <ul class="footer-links">
        <li @click="goHome" class="clickable">Home</li>
        <li class="clickable" @click="scrollTop">Back to Top</li>
      </ul>
    </div>

    <div class="footer-bottom">
      <p>© {{ new Date().getFullYear() }} FilmHive. All rights reserved.</p>
      <p class="tmdb-note">
        This product uses the TMDB API but is not endorsed or certified by TMDB.
        <a href="https://www.themoviedb.org/" target="_blank" rel="noopener">
          <img
            src="https://www.themoviedb.org/assets/2/v4/logos/v2/blue_short-8e7b30f73a4020692ccca9c88bafe5dcb6f8a62a4c6bc55cd9ba82bb2cd95f6c.svg"
            alt="TMDB Logo"
            class="tmdb-logo"
          />
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterPage",
  methods: {
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/").then(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.footer {
  background-color: black;
  color: white;
  padding: 20px;
  margin-top: auto;
  box-shadow: 0 -1px 8px rgb(115, 17, 17);
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.footer-logo {
  font-size: 20px;
  font-weight: bold;
  color: red;
  cursor: pointer;
}

.footer-links {
  list-style: none;
  display: flex;
  gap: 15px;
  margin: 0;
  padding: 0;
}

.footer-links li {
  cursor: pointer;
  color: white;
}

.footer-links li:hover {
  color: #ff4444;
}

.footer-bottom {
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  opacity: 0.9;
}

.tmdb-note {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  text-align: center;
  justify-content: center;
  margin-top: 15px;
}


.tmdb-note a {
  margin-left: 5px;
  vertical-align: middle;
}

.tmdb-logo {
  height: auto;
  width: 100px;
  max-width: 100%;
  vertical-align: middle;
  margin-left: 8px;
}

@media (max-width: 400px) {
  .tmdb-note {
    flex-direction: column;
    align-items: center;
  }

  .tmdb-logo {
    margin-left: 0;
    margin-top: 5px;
  }
}

</style>
